import useMediaQuery from "@mui/material/useMediaQuery";
import { colors } from "../config/app-constants";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import CheckIcon from "@mui/icons-material/Check";
import AttachMoneyRoundedIcon from "@mui/icons-material/AttachMoneyRounded";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import moment from "moment";
import Compressor from "compressorjs";
import { updateCategoryData } from "../store/action";

export function GetCurrentResolution() {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const isTablet = useMediaQuery("(max-width:900px)");
  const isLaptop = useMediaQuery("(max-width:1200px)");
  const isDesktop = useMediaQuery("(max-width:1536px)");

  if (isMobile) {
    return "mobile";
  } else if (isTablet) {
    return "tablet";
  } else if (isLaptop) {
    return "laptop";
  } else if (isDesktop) {
    return "desktop";
  }
}

// for table component
export function descendingComparator(a, b, orderBy) {
  if (orderBy === "category_count" || orderBy === "categories_count") {
    const getCount = (row) => {
      if (typeof row?.categories_count === "number") return row.categories_count;
      if (typeof row?.category_count === "number") return row.category_count;
      if (Array.isArray(row?.categories)) return row.categories.length;
      if (typeof row?.categories_count === "string" && !isNaN(Number(row.categories_count))) return Number(row.categories_count);
      if (typeof row?.category_count === "string" && !isNaN(Number(row.category_count))) return Number(row.category_count);
      return 0;
    };
    const valA = getCount(a);
    const valB = getCount(b);
    if (valB < valA) return -1;
    if (valB > valA) return 1;
    return 0;
  }
  if (typeof a[orderBy] === "string" || (typeof b[orderBy] === "string" && orderBy !== "phone")) {
    if (a[orderBy] === null) return 1;
    if (b[orderBy] === null) return -1;
    if (b[orderBy]?.toLowerCase() < a[orderBy]?.toLowerCase()) {
      return -1;
    }
    if (b[orderBy]?.toLowerCase() > a[orderBy]?.toLowerCase()) {
      return 1;
    }
    return 0;
  } else {
    if (a[orderBy] === null) return 1;
    if (b[orderBy] === null) return -1;
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }
}

export function getComparator(order, orderBy) {
  return order === "desc" ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export function customSort(data, order, orderBy) {
  return [...data].sort((a, b) => {
    const textA = a[orderBy];
    const textB = b[orderBy];
    const isNumericA = !isNaN(textA);
    const isNumericB = !isNaN(textB);
    if (isNumericA && isNumericB) {
      const numA = parseInt(textA);
      const numB = parseInt(textB);
      return order === "asc" ? numA - numB : numB - numA;
    }
    if (isNumericA && !isNumericB) {
      return order === "asc" ? -1 : 1;
    } else if (!isNumericA && isNumericB) {
      return order === "asc" ? 1 : -1;
    }
    return order === "asc" ? textA?.localeCompare(textB) : textB?.localeCompare(textA);
  });
}

export function splitDate(date) {
  var result = [];
  var counter = 0;
  for (var i = date.length - 1; i >= 0; i -= 1) {
    result[counter] = date[i];
    counter += 1;
  }
  var date = result[1].replace(/-/g, "/");
  const tConvert = (time) => {
    // Check correct time format and split into components
    time = time.toString().match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(""); // return adjusted time or original string
  };
  var time = tConvert(result[0].slice(0, -3));
  return { date, time };
}

export function GetSumArray(ary) {
  return ary.reduce(function (sum, value) {
    return sum + value;
  }, 0);
}

// array sort
export function compareStrings(a, b) {
  // Assuming you want case-insensitive comparison
  a = a.toLowerCase();
  b = b.toLowerCase();

  return a < b ? -1 : a > b ? 1 : 0;
}

export function onKeyPressed(evt) {
  if (evt.key === "e" || evt.key === "E" || evt.key === "." || evt.key === "+" || evt.key === "-") {
    evt.preventDefault();
  }
}

export function formatPhoneNumber(value) {
  // if input value is falsy eg if the user deletes the input, then just return
  if (!value) return value;

  // clean the input for any non-digit values.
  const phoneNumber = value.replace(/[^\d]/g, "");

  // phoneNumberLength is used to know when to apply our formatting for the phone number
  const phoneNumberLength = phoneNumber.length;

  // we need to return the value with no formatting if its less then four digits
  // this is to avoid weird behavior that occurs if you  format the area code to early

  if (phoneNumberLength < 4) return phoneNumber;

  // if phoneNumberLength is greater than 4 and less the 7 we start to return
  // the formatted number
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }

  // finally, if the phoneNumberLength is greater then seven, we add the last
  // bit of formatting and return it.
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
}

// modifiled phonenumber values formater only with dashes and avoiding brackets
export function formatPhoneNumberDashes(value) {
  if (!value) return value;
  const phoneNumber = value.replace(/[^\d]/g, "");
  const phoneNumberLength = phoneNumber.length;
  if (phoneNumberLength < 4) return phoneNumber;
  if (phoneNumberLength < 7) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3)}`;
  }
  return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
}

export function formatZip(value) {
  const newValue = value.toUpperCase();
  const length = value.length;
  // if (!value) return value;
  // const zip = value.replace(/[^\d]/g, '');
  // const zipLength = zip.length;
  // if (zipLength < 7) {
  //     return zip.slice(0, 6);
  // }
  // return zip.slice(0, 6);
  return newValue.slice(0, 6);
}
// check for special characters
function containsSpecialChars(str) {
  const specialChars = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  return specialChars.test(str);
}
//   check for white spaces
function containsWhitespace(str) {
  return /\s/.test(str);
}

export function formatState(value) {
  const newValue = value.toUpperCase();
  const length = value.length;
  if (
    newValue === "1" ||
    newValue === "2" ||
    newValue === "3" ||
    newValue === "4" ||
    newValue === "5" ||
    newValue === "6" ||
    newValue === "7" ||
    newValue === "8" ||
    newValue === "9" ||
    newValue === "0" ||
    containsSpecialChars(value) ||
    containsWhitespace(value)
  ) {
    newValue.preventDefault();
  } else if (length <= 2) {
    return newValue;
  } else value.preventDefault();
}

export function GetTabWidth(length) {
  if (length === 1) {
    return "100% !important";
  } else if (length === 2) {
    return "50% !important";
  } else if (length === 3) {
    return "33.33%";
  } else if (length >= 4) {
    return "25%";
  }
}

export function InspStatusBg(status) {
  console.log("InspStatusColor", status)
  if (status === "In-Progress" || status === "In Progress") {
    return colors["IN_PROGRESS_BG"];
  }
  if (status === "Published") {
    return colors["PUBLISHED_BG"];
  }
  if (status === "Complete") {
    return colors["COMPLETE_BG"];
  }
  if (status === "Scheduled") {
    return colors["SCHEDULED_BG"];
  }
  if (status === "Cancelled") {
    return colors["CANCELLED_BG"];
  }
  if (status === "Draft") {
    return colors["DRAFT_BG"];
  }
  if (status === null) {
    return colors["SCHEDULED_BG"];
  }
}

export function InspStatusColor(status) {
  if (status === "In-Progress" || status === "In Progress") {
    return colors["IN_PROGRESS"];
  }
  if (status === "Published") {
    return colors["PUBLISHED"];
  }
  if (status === "Complete") {
    return colors["COMPLETE"];
  }
  if (status === "Scheduled") {
    return colors["SCHEDULED"];
  }
  if (status === "Cancelled") {
    return colors["CANCELLED"];
  }
  if (status === "Draft") {
    return colors["DRAFT"];
  }
  if (status === null) {
    return colors["SCHEDULED"];
  }
}

export const summaryData = [
  {
    id: 0,
    title: "inspections scheduled",
    icon: <CalendarMonthIcon className="icon" />,
    color: colors["INSPECTION_SCHEDULED"],
  },
  {
    id: 1,
    title: "inspections completed",
    icon: <CheckIcon className="icon" />,
    color: colors["INSPECTION_COMPLETED"],
  },
  {
    id: 2,
    title: "collected payments",
    icon: <AttachMoneyRoundedIcon className="icon" />,
    color: colors["COLLECTED_PAYMENTS"],
  },
  {
    id: 3,
    title: "fees owed",
    icon: <AttachMoneyRoundedIcon className="icon" />,
    color: colors["FEES_OWED"],
  },
];

export const ConvertDate = (date) => {
  return moment(date).format("YYYY/MM/DD");
};

export function formatCost(value) {
  let result;
  let parts = value.toString().split(".");
  let whole_num = parts[0].replace(/\D/g, ""),
    dec = parts[1];
  // use the below commented number for numeric calculations(num without commas)
  let calc_num = Number(dec !== undefined ? whole_num + "." + dec : whole_num);
  result = new Intl.NumberFormat("en-EN").format(whole_num);
  result = dec !== undefined ? result + "." + dec : result;
  return { formatted: result, calculation: calc_num };
}

export const BootstrapTooltip = styled(({ className, ...props }) => <Tooltip {...props} arrow classes={{ popper: className }} />)(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: theme.palette.common.black,
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.black,
  },
}));

// Only one container scroll animation runs at a time.
let activeScrollFrame = null;

// Animates `container` to `top` over a fixed duration. This is used instead of
// scrollTo({ behavior: "smooth" }) because the native easing stretches its duration with the
// distance travelled — scrolling past a long list feels nothing like scrolling past a short one —
// and the native animation is dropped outright when the scroll starts in the same frame as a
// re-render of the list being scrolled.
export const smoothScrollContainerTo = (container, top, duration = 400) => {
  if (!container) return;
  if (activeScrollFrame) cancelAnimationFrame(activeScrollFrame);
  const startTop = container.scrollTop;
  const distance = top - startTop;
  if (Math.abs(distance) < 1) return;
  const startTime = performance.now();
  const ease = (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t);
  const step = (now) => {
    const progress = Math.min((now - startTime) / duration, 1);
    container.scrollTop = startTop + distance * ease(progress);
    activeScrollFrame = progress < 1 ? requestAnimationFrame(step) : null;
  };
  activeScrollFrame = requestAnimationFrame(step);
};

// Smoothly scrolls `element` into view inside its own scroll container, instead of relying on
// scrollIntoView (which also scrolls every ancestor, including the page behind a modal).
// `offset` leaves room for a sticky header rendered inside the container. The target is clamped
// to the container's scroll range, so the behaviour is the same for a short and a long list.
export const scrollElementIntoContainerView = (container, element, offset = 0) => {
  if (!container || !element) return;
  const maxScrollTop = container.scrollHeight - container.clientHeight;
  if (maxScrollTop <= 0) return;
  const relativeTop = element.getBoundingClientRect().top - container.getBoundingClientRect().top;
  const target = container.scrollTop + relativeTop - offset;
  smoothScrollContainerTo(container, Math.min(Math.max(target, 0), maxScrollTop));
};

export const timestamp = () => {
  const now = new Date();
  return moment
    .utc(now ? new Date(now) : new Date())
    .format("YYYY-MM-DD HH:mm:ss");
};

export const timestampWithMinuteChange = () => {
  const currentTimestamp = timestamp();
  const currentTimestampDate = new Date(currentTimestamp);
  currentTimestampDate.setMinutes(currentTimestampDate.getMinutes() - 5);
  const result = currentTimestampDate
    .toISOString()
    .replace("T", " ")
    .replace(/\.\d+Z$/, "");
  return result;
};

export const getImageDimensions = (file) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      const imgWidth = img.width;
      const imgHeight = img.height;
      resolve({ imgWidth, imgHeight });
    };
    img.src = URL.createObjectURL(file);
  });
};

export const resizeImage = (file, width, height, quality) => {
  return new Promise((resolve, reject) => {
    new Compressor(file, {
      width,
      height,
      quality, // Set the image compression quality
      success(result) {
        resolve(result);
      },
      error(err) {
        reject(err);
      },
    });
  });
};

export const decodeEntities = (encodedString) => {
  const textarea = document.createElement("textarea");
  textarea.innerHTML = encodedString;
  let decoded = textarea.value;
  return decoded;
};

export function convertFontToSpan(htmlString) {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString?.innerHTML, "text/html");
  const sizeToPx = { 1: "10px", 2: "12px", 3: "14px", 4: "16px", 5: "18px", 6: "20px", 7: "22px" };
  function replaceFontWithSpan(element) {
    element.querySelectorAll("font").forEach((font) => {
      const fontSize = sizeToPx[font.getAttribute("size")] || "14px";
      const fontColor = font.getAttribute("color");
      const span = document.createElement("span");
      span.style.fontSize = fontSize;
      if (fontColor) span.style.color = fontColor;
      span.innerHTML = font.innerHTML;
      replaceFontWithSpan(span);
      font.replaceWith(span);
    });
  }
  replaceFontWithSpan(doc.body);
  return { innerHTML: doc.body.innerHTML || "" };
}

// Froala turns a blank line into <p>&nbsp;</p> (sometimes with stray spaces or a <br> alongside),
// and a non-breaking space does not collapse the way ordinary whitespace does - so those blocks
// show up as visible gaps wherever the saved HTML is rendered. Strip them off the top and bottom of
// the content and trim the padding hanging off the outermost real text. Blank blocks sitting between
// two real paragraphs are left alone: there they are deliberate spacing.
const EDITOR_BLANK_CHARS = /[\s\u00a0\u200b]/g;
const LEADING_BLANK = /^[\s\u00a0\u200b]+/;
const TRAILING_BLANK = /[\s\u00a0\u200b]+$/;
const EDITOR_MEDIA = "img, table, iframe, hr, input, video, audio";

export function trimEditorHtml(htmlString) {
  if (!htmlString) return "";
  const parser = new DOMParser();
  const { body } = parser.parseFromString(htmlString, "text/html");

  // An empty-looking block still counts as content when it carries media, so those are never dropped.
  const isBlank = (node) => {
    if (node.nodeType === Node.TEXT_NODE) return node.textContent.replace(EDITOR_BLANK_CHARS, "").length === 0;
    if (node.nodeType !== Node.ELEMENT_NODE) return true;
    if (node.nodeName === "BR") return true;
    // matches() as well as querySelector(), so a table whose cells all happen to be empty is
    // still recognised as content rather than being thrown away.
    if (node.matches(EDITOR_MEDIA) || node.querySelector(EDITOR_MEDIA)) return false;
    return node.textContent.replace(EDITOR_BLANK_CHARS, "").length === 0;
  };

  while (body.firstChild && isBlank(body.firstChild)) body.removeChild(body.firstChild);
  while (body.lastChild && isBlank(body.lastChild)) body.removeChild(body.lastChild);
  if (!body.firstChild) return "";

  // Walks into the outermost block from one side, shaving padding off the text nodes it meets and
  // stopping at the first thing that is real content: surviving text, or a piece of media. Stopping
  // at media matters because the space in "<p>&nbsp;<img> text</p>" separates two things and is not
  // padding, unlike the one ahead of the image.
  const trimEdge = (node, fromEnd) => {
    if (!node) return false;
    const pattern = fromEnd ? TRAILING_BLANK : LEADING_BLANK;
    if (node.nodeType === Node.TEXT_NODE) {
      node.textContent = node.textContent.replace(pattern, "");
      return node.textContent.length > 0;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return false;
    if (node.matches(EDITOR_MEDIA)) return true;
    const children = Array.from(node.childNodes);
    if (fromEnd) children.reverse();
    return children.some((child) => trimEdge(child, fromEnd));
  };
  trimEdge(body.firstChild, false);
  trimEdge(body.lastChild, true);

  return body.innerHTML;
}

export const checkForInvalidImages = (htmlContent) => {
  const imgRegex = /<img.*?src=['"](.*?)['"].*?>/g;
  const imgSrcMatches = htmlContent.match(imgRegex) || [];
  let hasUnsupportedImages = false;
  let hasCloudImages = false;
  imgSrcMatches.forEach((imgSrcMatch) => {
    const srcMatch = /src=['"](.*?)['"]/g.exec(imgSrcMatch);
    if (srcMatch && srcMatch[1]) {
      const imgSrc = srcMatch[1];
      const isBase64 = imgSrc.startsWith("data:image/");

      if (isBase64) {
        const extension = imgSrc.split(";")[0].split("/")[1].toLowerCase();
        if (!["jpg", "jpeg", "png"].includes(extension)) {
          hasUnsupportedImages = true;
        }
      } else {
        hasCloudImages = true;
      }
    }
  });

  return { hasUnsupportedImages, hasCloudImages };
};

export function filterObjectsUptoLine(prevData, templateIndex, categoryIndex, lineIndex) {
  let filteredData = JSON.parse(JSON.stringify(prevData));
  let filteredTemplateObject = filteredData?.inspectiontemplates[templateIndex];
  let filteredCategoryObject = filteredTemplateObject?.categories[categoryIndex];
  let filteredLineObject = filteredCategoryObject?.lines[lineIndex];
  filteredCategoryObject.lines = [filteredLineObject];
  filteredTemplateObject.categories = [filteredCategoryObject];
  filteredData.inspectiontemplates = [filteredTemplateObject];
  return filteredData;
}

export function filterObjectsUptoCategory(catList = [], categoryId, dispatch, prevData = []) {
  const safePrevData = Array.isArray(prevData) ? prevData : [];
  const safeCatList = Array.isArray(catList) ? catList : [];

  const categoryIndex = safePrevData.findIndex(
    (item) =>
      (item?.category_id && item?.category_id === categoryId) ||
      (item?.id && item?.id === categoryId) ||
      (item?.uuid && item?.uuid === categoryId)
  );

  const oldCategoryIndex = safeCatList.findIndex(
    (item) =>
      (item?.category_id && item?.category_id === categoryId) ||
      (item?.id && item?.id === categoryId) ||
      (item?.uuid && item?.uuid === categoryId)
  );

  let filteredData;
  if (categoryIndex !== -1 && oldCategoryIndex !== -1) {
    filteredData = [...safePrevData];
    filteredData[categoryIndex] = safeCatList[oldCategoryIndex];
  } else if (oldCategoryIndex !== -1) {
    filteredData = [...safePrevData, safeCatList[oldCategoryIndex]];
  } else {
    filteredData = [...safePrevData];
  }
  dispatch(updateCategoryData(filteredData));
}

export function filterObjectsUptoTemplate(prevData, templateIndex) {
  let filteredData = JSON.parse(JSON.stringify(prevData));
  let filteredTemplateObject = filteredData?.inspectiontemplates[templateIndex];
  filteredData.inspectiontemplates = [filteredTemplateObject];
  return filteredData;
}

export function filterPdfTemplateData(prevData, templateIndex, filteredPDFData, mergeId) {
  let filteredData = JSON.parse(JSON.stringify(prevData));
  let filteredTemplateObject = filteredData?.inspectiontemplates[templateIndex];
  filteredTemplateObject.pdf_data = filteredPDFData;
  let pdfDataFilteredWithmergeID = filteredTemplateObject.pdf_data.filter((element) => element.merge_id === mergeId);
  filteredTemplateObject.pdf_data = pdfDataFilteredWithmergeID;
  filteredTemplateObject.pdf_categories = [];
  filteredData.inspectiontemplates = [filteredTemplateObject];
  return filteredData;
}